import { User } from 'src/types/user';
import api from './axiosConfig';

type GetProviderInfo = {
  providerInfo: User;
  error: boolean;
};

export const getProviderInfo = async (userId: string): Promise<GetProviderInfo> => {
  try {
    const axiosObj = await api({
      method: 'GET',
      url: `/v2/users/${userId}/info`,
    });

    return {
      providerInfo: axiosObj.data.userFullInfo,
      error: false,
    };
  } catch (e) {
    console.error(e);
    return {
      providerInfo: null,
      error: true,
    };
  }
};
